import { FC, memo, useMemo } from 'react';
import { Image } from '@shuwen/wenlv-web-activity-library';
import { Carousel } from 'antd';
import { getAssetUrl } from '@/utils/common';
import styles from './index.module.scss';
import { TimeLineItem } from '@/store/types';

interface Props {
  index: number;
  size: TimeLineItem;
}

const Card: FC<Props> = ({ index, size }) => {

  const data = useMemo(() => {
    const item = size?.ext_neighborList?.filter(i => i.vertex?.author && i.vertex?.content && i.vertex?.dynasty);
    if (item?.length) return item;
    return null;
  }, [size]);

  return (
    <div className={styles.card}>
      <div
        className={styles.title}
        style={
          size.name.length > 6 ?
            {
              fontSize: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            } :
            {}
        }
      >
        {index + 1}.{size.name}
      </div>
      <div 
      className={styles.circle} 
      style={{ 
        width: size.size, 
        height: size.size,
        backgroundImage: getAssetUrl('images/route/timeLine/circleBg.png', 'url')
      }}>
        <div
          className={styles.imgWrap}
          style={{
            width: (size?.size || 263) / 1.8,
            height: (size?.size || 263) / 1.8
          }}
        >
          <Image src={size?.image} className={styles.img} loading="lazy" />
        </div>
        <div className={styles.line}>
          <div className={styles.top}>
            <div className={styles.white} />
          </div>
          <div className={styles.dashedLine} />
          <div className={styles.ball} />
        </div>
      </div>
      <div className={styles.detail} style={{ top: (size.size || 200) + 100 }}>
        {
          data?.length ?
            <Carousel
              className={styles.carousel}
              dots={false}
              autoplay
              autoplaySpeed={10000}
            >
              {
                data.map((item) => (
                  <div className={styles.item} key={item.vertex.entityId}>
                    <div className={styles.time}>{item.vertex.historical_era || item.vertex.dynasty}</div>
                    <div className={styles.theme}>《{item.vertex.name}》</div>
                    <div className={styles.author}>{item.vertex.author[0]}</div>
                    <div className={styles.poem}>{item.vertex.content}</div>
                  </div>
                ))
              }
            </Carousel> :
            null
        }
      </div>
    </div>
  )
}

export default memo(Card);
